/**
 * Component for displaying form field validation errors
 */
export function FieldError({
  errors,
}: {
  errors: Array<string | undefined> | undefined;
}) {
  const cleanErrors = (errors ?? []).filter(Boolean) as string[];
  if (!cleanErrors.length) return null;

  return <p className="text-sm text-red-500">{cleanErrors.join(', ')}</p>;
}

